<template>
    <div v-show="$store.getters['auth/isAuth'] === false">
        <div class="logo mb-5 text-center">
            <router-link :to="{ name: 'login' }">
                <img v-if="!isMobile" src="@/assets/lh-logo.png">
                <img v-else src="@/assets/lh-logo.svg">
            </router-link>
        </div>

        <form @submit.prevent="submit">
            <div class="lead mb-4 text-center">Личный кабинет</div>

            <div v-show="error" class="text-center lead text-danger mb-4">{{ error }}</div>

            <div class="form-group">
                <label for="identifier">Номер телефона или почта</label>
                <input id="identifier" v-model="identifier" type="text" class="form-control" placeholder="Телефон / Почта" tabindex="1" autofocus>
            </div>

            <div class="form-group">
                <div class="d-flex align-items-center justify-content-between">
                    <label for="password">Пароль</label>
                    <router-link :to="{ name: 'forgot' }" class="mb-1">Забыли пароль?</router-link>
                </div>
                <input id="password" v-model="password" type="password" class="form-control" placeholder="Пароль" tabindex="2">
            </div>

            <div class="my-4" style="line-height: 1.4rem">
                <div class="custom-control custom-checkbox">
                    <input id="guest" v-model="remember" type="checkbox" class="custom-control-input" tabindex="3">
                    <label class="custom-control-label" for="guest">Чужой компьютер</label>
                </div>
            </div>

            <div class="my-4">
                <button class="btn btn-lg-192 btn-primary" type="submit" tabindex="4">Вход</button>
            </div>

            <div class="text-center my-5">
                Нет учетной записи?
                <router-link :to="{ name: 'registration' }">Зарегистрируйтесь</router-link>.
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            identifier: '',
            password: '',
            remember: false
        }
    },
    computed: {
        error() {
            return this.$store.state.auth.errorMessage
        },
        isMobile() {
            return this.$store.state.isMobile
        }
    },
    methods: {
        async submit() {
            let done = await this.$store.dispatch('auth/login', {
                username: this.identifier,
                password: this.password,
                remember: !this.remember
            })

            if (done) {
                if (this.$store.state.auth.isAdmin) {
                    this.$router.push({ name: 'admin' })
                } else {
                    await this.$store.dispatch('company/profile/fetch')
                    this.$router.push({ name: 'home' })
                }
            }
        }
    }
}
</script>
